import Typography from "@marginly/ui/components/typography";
import cn from "classnames";
import React, { useState } from "react";

import Space from "@/components/common/space";
import { COUNT_LINES } from "@/components/raffle/constants";
import { CommonModal } from "@/components/raffle/results/common-modal/common-modal";
import { TimerLabel } from "@/components/raffle/timer-label";
import { getPlural } from "@/util/get-plural";

import {
  GroupedTickets,
  Header,
  RaffleLine,
  RaffleSelectLine,
  SecondaryHeader,
} from "./personal-tickets-modal.styled";

export const PersonalTicketsModal = ({
  raffles,
  tickets,
  onHide,
}: {
  raffles: Raffle[];
  tickets: Ticket[];
  onHide?: () => void;
}) => {
  const [openedRaffleIndex, setOpenedRaffleIndex] = useState<number | null>(
    null,
  );

  const groupedTickets = tickets.reduce((grouped, ticket) => {
    if (!grouped[ticket.raffleId]) {
      grouped[ticket.raffleId] = [];
    }
    grouped[ticket.raffleId].push(ticket);
    return grouped;
  }, [] as Ticket[][]);

  const currentTickets =
    openedRaffleIndex === null
      ? null
      : groupedTickets[raffles[openedRaffleIndex].id];

  return (
    <CommonModal
      onHide={onHide}
      header={
        openedRaffleIndex === null ? (
          <Header>
            <Typography headerL>Check your tickets</Typography>
          </Header>
        ) : (
          <SecondaryHeader>
            <div
              className="back"
              onClick={() => {
                setOpenedRaffleIndex(null);
              }}
            >
              <img src="/images/arrow-left.svg" alt="Back" />
            </div>
            <Typography headerS>
              {getPlural(currentTickets?.length, "ticket")}{" "}
              in {COUNT_LINES[raffles[openedRaffleIndex].index]} Raffle
            </Typography>
            <Space height={24} heightMobile={24} />
          </SecondaryHeader>
        )
      }
    >
      {openedRaffleIndex === null ? (
        raffles.map((raffle) => (
          <>
            <Space height={16} heightMobile={16} />
            <RaffleSelectLine
              key={raffle.raffleDate}
              {...(raffle.winnersSelectedAt && {
                onClick: () => {
                  setOpenedRaffleIndex(raffle.index);
                },
                className: "clickable",
              })}
            >
              {raffle.winnersSelectedAt ? (
                <>
                  <span>
                    {getPlural(groupedTickets[raffle.id]?.length, "ticket")} in{" "}
                    {COUNT_LINES[raffle.index]} Raffle
                  </span>
                  <img src="/images/arrow-right.svg" alt="Open" />
                </>
              ) : (
                <>
                  <span>{COUNT_LINES[raffle.index]} Raffle</span>
                  <TimerLabel
                    endTime={new Date(raffle.raffleDate)}
                    textBefore="Start due in "
                  />
                </>
              )}
            </RaffleSelectLine>
          </>
        ))
      ) : (
        <GroupedTickets>
          {currentTickets?.map((ticket) => (
            <RaffleLine key={ticket.number}>
              <span className="wide">
                <span className="number">
                  <img
                    src={
                      ticket.winAmountUsd
                        ? ticket.winAmountUsd === 50
                          ? "/images/prize-50.png"
                          : ticket.winAmountUsd === 1000
                          ? "/images/prize-1000.png"
                          : "/images/ticket-green.svg"
                        : "/images/ticket-black.svg"
                    }
                    alt=""
                  />
                  #{ticket.number}
                </span>
              </span>
              <span className={cn("win-amount", { won: ticket.winAmountUsd })}>
                {ticket.winAmountUsd ? `Won $${ticket.winAmountUsd}` : "No win"}
              </span>
            </RaffleLine>
          ))}
        </GroupedTickets>
      )}
    </CommonModal>
  );
};
